module.exports = __webpack_public_path__ + "img/bcc098.15af1a01.jpeg";